const PUBLIC_ROOT = (process.env.PUBLIC_URL || 'https://www.typortal.com').replace(/\/+$/, '');

export const LOGO_URL = `${PUBLIC_ROOT}/assets/typ-logo.png`;
